import { AIConversationGenerationStatus } from '../../../../constants/aiAgents'
import {
  EMPTY_LIST,
  EMPTY_OBJECT,
  EMPTY_STRING,
} from '../../../../constants/common'
import { isValueNumberType } from '../../../../utils/common'
import { GRETA_AI_CHAT_SETTLED_GENERATION_GRACE_MS } from '../../GretaAIChat.constants'
import { getIsGretaAIChatChatRunning } from '../../GretaAIChat.utils'

function getIsGretaAIChatStaleRunning({ chat, requestedAt, settledAtById }) {
  return (
    getIsGretaAIChatChatRunning(chat) &&
    getIsGretaAIChatSettledRecently({ id: chat.id, requestedAt, settledAtById })
  )
}

export function getIsGretaAIChatSettledRecently({
  id,
  requestedAt,
  settledAtById,
}) {
  return (
    settledAtById.has(id) &&
    requestedAt - settledAtById.get(id) <
      GRETA_AI_CHAT_SETTLED_GENERATION_GRACE_MS
  )
}

export function mapGretaAIChatChat(chat) {
  return {
    generationStatus: chat.generation_status ?? null,
    id: chat.id,
    title: chat.title ?? EMPTY_STRING,
    updatedAt: chat.updated ? new Date(chat.updated).getTime() : 0,
  }
}

export function mapGretaAIChatChats(response) {
  return (response?.data?.results ?? EMPTY_LIST).map(mapGretaAIChatChat)
}

export function getHasNextGretaAIChatChatsPage(response) {
  const { page, pages } = response?.data ?? EMPTY_OBJECT

  return isValueNumberType(page) && isValueNumberType(pages) && page < pages
}

export function getGretaAIChatChatsWithoutId(chats, id) {
  return chats.filter(chat => chat.id !== id)
}

export function getHasGretaAIChatChatId(chats, id) {
  return chats.some(chat => chat.id === id)
}

export function mergeGretaAIChatChats(primaryChats, secondaryChats) {
  const knownIds = new Set(primaryChats.map(chat => chat.id))

  return [
    ...primaryChats,
    ...secondaryChats.filter(chat => !knownIds.has(chat.id)),
  ]
}

export function getHasGretaAIChatStaleRunning({
  chats,
  requestedAt,
  settledAtById,
}) {
  return chats.some(chat =>
    getIsGretaAIChatStaleRunning({ chat, requestedAt, settledAtById })
  )
}

// A list read just after a turn settled can still say `running` — the replica lags.
export function getGretaAIChatChatsWithoutStaleRunning({
  chats,
  requestedAt,
  settledAtById,
}) {
  return chats.map(chat =>
    getIsGretaAIChatStaleRunning({ chat, requestedAt, settledAtById })
      ? { ...chat, generationStatus: AIConversationGenerationStatus.Idle }
      : chat
  )
}
